// extracted by mini-css-extract-plugin
export default {"greetings":"HomeHeader_greetings__8Glnb","title":"HomeHeader_title__XZMQW","subtitle":"HomeHeader_subtitle__4kewv"};